import dayjs, { type Dayjs } from "dayjs";
import type { IServiceIntervalDto, IServiceInterval } from "./IServiceInterval";
import { ServiceIntervalState } from "./ServiceIntervalState";

export class ServiceInterval implements IServiceInterval
{

    serviceScheduleId: string;
    serviceIntervalId: string;
    year: number;
    km: number;
    months: number;
    state: ServiceIntervalState;
    dateCompleted?: Dayjs;

    constructor( model: IServiceIntervalDto, serviceScheduleId: string )
    {
        this.serviceScheduleId = serviceScheduleId;
        this.serviceIntervalId = model.serviceIntervalId;
        this.km = model.km;
        this.months = model.months;
        this.state = model.state;
        this.dateCompleted = model.dateCompleted != null ? dayjs( model.dateCompleted ) : undefined;
        this.year = Math.ceil( this.months / 12 );
    }

    get isDone()
    {
        return this.state != ServiceIntervalState.NotDone;
    }

    set isDone( value: boolean )
    {
        if( this.state == ServiceIntervalState.MarkedDoneFromDms ) return;
        this.state = value ? ServiceIntervalState.MarkedDoneByUser : ServiceIntervalState.NotDone;
    }

}